<script>
	import CreateTaskForm from "./CreateTaskForm.svelte";

	export let id;
</script>

<CreateTaskForm isEdit={id} />
